import React from 'react'
import { CButton } from '@coreui/react'

const RButtonDanger = ({ children, type, ...props }) => {
    return <CButton type={type ?? 'button'} size="sm" color='danger' className="text-white" {...props}>{children}</CButton>
}

export default RButtonDanger
